/// <reference path='../../interfaces/interfaces.d.ts' />

import IToasterService = toaster.IToasterService;
import IFormController = angular.IFormController;
import {IStateService} from 'angular-ui-router';

'use strict';

class NewEventController {
    public static $inject = [
        '$rootScope',
        '$state',
        '$uibModal',
        'Orgs',
        'User',
        'Calendar',
        'toaster'
    ];

    public datePickerConfig: any;
    public repeatCases: string[];
    public isRepeated: boolean;
    public eventTypes: any;
    public hasPermission: any;
    public eventTypeIcons: any;

    public event: IEvent = {
        allDay: false,
        startTime: moment(),
        endTime: moment().add(15, 'minutes'),
        startDate: moment().toDate(),
        endDate: moment().toDate(),
        description: '',
        start: undefined,
        end: undefined,
        rule: undefined,
        title: '',
        id: undefined,
        calendar_type: undefined,
        end_recurring_period: undefined
    };

    constructor(
        private $scope: ng.IScope,
        private $state: IStateService,
        private $uibModal: any,
        private Org: IOrgsService,
        private User: IUserService,
        private Calendar: ICalendarService,
        private toaster: IToasterService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.hasPermission = User.hasPermission;

        if (Object.keys($state.params['tempEvent']).length > 0) {
            this.event.startTime = $state.params['tempEvent']['start'];
            this.event.endTime = $state.params['tempEvent']['end'];
            this.event.title = $state.params['tempEvent']['title'];
            this.event.event_type = $state.params['tempEvent']['event_type'];
            this.event.startDate = $state.params['tempEvent']['start'].toDate();
            this.event.endDate = this.event.startDate;
            this.event.rule = $state.params['tempEvent']['rule'];
            this.event.calendar_type = $state.params['tempEvent']['calendar_type'];
            this.isRepeated = !!this.event.rule;
        }

        Calendar.makeTitle(this.event);
        this.eventTypes = Calendar.getEventTypes();
        this.repeatCases = Calendar.getRepeatCases();
        this.eventTypeIcons = Calendar.getEventTypeIcons();
        this.datePickerConfig = {
            formatDay: 'd',
            formatDayTitle: 'MMM yyyy',
            showWeeks: false
        };
    }

    public changeAllDay(): void {
        if (this.event.allDay) {
            this.event.startTime.hour(0).minute(0);
            this.event.endTime.hour(23).minute(59);
        } else {
            this.event.startTime.hour(0).minute(0);
            this.event.endTime.hour(23).minute(45);
        }
    }

    public submitForm(form: IFormController): void {
        let promise: any;
        form.$submitted = true;
        if (form.$valid) {
            this.event.start = moment(this.event.startDate).hour(this.event.startTime.hour()).minute(this.event.startTime.minute());
            this.event.end = moment(this.event.endDate).hour(this.event.endTime.hour()).minute(this.event.endTime.minute());

            if (this.event.start.valueOf() > this.event.end.valueOf()) {
                this.toaster.pop('warning', 'Validation Failed', 'Start date must be earlier than end date!');
            } else {
                if (this.event.calendar_type === 'holidays') {
                    promise = this.Calendar.createHoliday(this.event);
                } else {
                    if (!this.event.event_type) {
                        this.toaster.pop('error', 'Validation Failed', 'Please select event type');
                        return;
                    }
                    promise = this.Calendar.createEvent(this.event);
                }
                promise.then(() => {
                    this.$state.go(this.$state.$current['parent']['navigable']['self']['name']);
                    this.toaster.pop('success', 'Success', 'Event successfully added');
                    // update announcement count
                    this.$scope.$emit('$incrementAnnounceCounter');
                }, (response: Restangular.IResponse) => {
                    if (response.status === 400) {
                        this.toaster.pop('error', 'Validation Failed', response.data);
                    } else {
                        this.toaster.pop('error', 'Server error', 'Please try again later');
                    }
                });
            }
        } else {
            this.toaster.pop('warning', '', 'Required fields are not filled');
        }
    }

    public discard(): void {
        this.$state.go(this.$state.$current['parent']['navigable']['self']['name']);
    }

    public repeatedChange(): void {
        if (!this.isRepeated) {
            this.event.rule = undefined;
            this.event.end_recurring_period = undefined;
        } else {
        this.showRepeatModal();
        }
    }

    public showRepeatModal(): void {
        if (this.isRepeated) {
            let modalInstance: any = this.$uibModal.open({
                controller: 'RepeatModalController',
                controllerAs: 'modal',
                templateUrl: '/static/templates/modals/repeat_modal.html',
                resolve: {
                    event: (): any => {
                        return this.event;
                    }
                },
            });

            modalInstance.result.then((response: any) => {
                if (response) {
                    this.event.rule = response.rule;
                    this.event.end_recurring_period = response.end_recurring_period;
                }
            }, (result: any) => {
            if (!this.event.rule) {
                this.isRepeated = false;
                this.repeatedChange();
            }
            });
        }
    }

    public setEventType(event: any): void {
        this.event.event_type = event;
    }
}

angular.module('beneple.calendar').controller('NewEventController', NewEventController);



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/controllers/new-event.controller.ts